import { useDispatch } from 'react-redux';

import Button from './Button';
import ErrorState from './ErrorState';

type Props = {
  eventId: string | null;
};

/** Full-viewport fallback for an uncaught render error. */
export default function ErrorFallback({ eventId }: Props) {
  const dispatch = useDispatch();

  return (
    <ErrorState
      fullscreen
      body="An unexpected error occurred. We've been notified and are looking into it. Reload the page to continue, or sign out."
      reference={eventId ? `Error reference: ${eventId}` : null}
      actions={
        <>
          <Button
            label="Reload page"
            size="small"
            onClick={() => window.location.reload()}
          />
          <Button
            label="Sign out"
            variant="text"
            colorScheme="black"
            size="small"
            onClick={() => dispatch({ type: 'LOGOUT' })}
          />
        </>
      }
    />
  );
}
